<template>
    <div >
        <br><br><br><br><br><br><br><br><br><br><br>
        <!-- MAIN CONTENT ================================================== -->
        <div class="row justify-content-center">
            <div class="card shadow-none pd-20 mx-auto wd-300 text-center bd-1 align-self-center">
            <div class="text-center">
               <img src="https://sshsbu.e-planningbmd.id/assets/images/bandung.png" class="rounded-circle img-fluid wd-60 mg-y-20" alt="">			   
            </div>
            <div class="clearfix">
                <div class="alert alert-danger" role="alert">
                    Halaman ini masih dalam pengerjaan!!!
                </div>
            </div>
         </div>
         
        </div>
        <!-- END MAIN CONTENT -->
        <br><br><br><br><br><br><br><br><br><br><br>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            title: 'FTSL',
            titleTemplate: '%s - Kode Akses'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                kodeAkses: {},
                form: {
                    akses: '',
                },
            }
        },
        created() {
            this.getData();
        },
        components: {
        },
        methods: {
            getData() {
                this.$http.get(this.baseUrl + 'admin/master/akses', {
                    params: {
                        keywords: this.keywords,
                    }
                })
                    .then((response) => {
                        this.form.akses = response.data.data.akses;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                    });
            },
            submitForm() {
                this.$http.post(this.baseUrl + 'admin/master/akses/save', this.form)
                    .then(() => {
                        this.$swal({
                            icon: 'success',
                            title: "success",
                            text: 'Kode Akses berhasil diperbaharui',
                            showConfirmButton: false,
                            timer: 1500
                        })
                        this.getData()
                    })
                    .catch(error => {
                        console.log(error.response.data)
                    });
            },
        },
    };
</script>
<style>
    /* style sweetalert */
    .swal2-html-container {
        display: block;
        text-align: center;
    }
</style>